

const overrideAtmAddToTrolleyMapper = require('../../../../trolley/atmmapper/override-add-trolley-mapper.js');

const getCategoryName = (categories, atLevel) => {
    return categories.find(({ Level }) => Level === atLevel) || { Name: '' };
};

module.exports = function ({ product, crossSellType, isSponsored, promoteIQCampaignId, eventData }) {
    const { Name: topLevelCategoryName } = getCategoryName(product.Categories, 0);
    const { Name: subLevelCategoryName } = getCategoryName(product.Categories, 1);
    const event = {
        event: 'BWSAUprodView',
        eventContext: {
            area: 'product page',
            promoteIQCampaignId: promoteIQCampaignId ? promoteIQCampaignId : null,
            product: {
                price: product.Price,
                productInfo: {
                    productName: product.ProductData.name,
                    brandName: product.ProductData.brandName,
                    productTitle: product.ProductData.title,
                    wasUnitPrice: product.WasPrice,
                    currentUnitPrice: product.Price,
                    isSpecial: product.IsOnSpecial,
                    webPackType: product.ProductData.webpacktype,
                    productUnitQuantity: product.ProductData.productunitquantity,
                    productSKU: product.Stockcode,
                    parentstockcode: product.ProductData.parentstockcode,
                    liquorSize: product.ProductData.liquorsize,
                    liquorStyle: product.ProductData.liquorstyle,
                    vintage: product.ProductData.vintage,
                    varietal: product.ProductData.varietal,
                    productCategory: topLevelCategoryName,
                    productSubCategory: subLevelCategoryName,
                    countryOfOrigin: product.ProductData.countryoforigin,
                    regionOfOrigin: product.ProductData.regionoforigin,
                    stateOfOrigion: product.ProductData.stateoforigin,
                    boAvailability: product.BackorderStockOnHand > 0,
                    foAvailability: product.StockOnHand > 0,
                    isSponsored: isSponsored ? 'yes' : 'no'
                }
            },
            typeOfCrossSell: crossSellType,
            eventID: product.eventId
        }
    };

    if (eventData) {
        Object.assign(event.eventContext, {
            eventCampaignName: eventData.campaignName,
            eventPlace: eventData.place,
            eventPosition: eventData.position,
            eventType: eventData.type
        });
    }

    if (event && event.eventContext) {
        overrideAtmAddToTrolleyMapper(event.eventContext);
    }

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atmmapper/product-view-mapper.js
 **/